"use client"

// Modified from https://github.com/vineethtrv/css-loader, MIT
import { css, keyframes } from "@emotion/css"
import styled from "@emotion/styled"
import React from "react"

import { baseTheme } from "@/shared-module/common/styles"

const bounce = keyframes`
  0%,
  60%,
  100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-3px);
  }
`

interface DotProps {
  delaySeconds: number
}

// Hoisted because emotion re-serializes and re-hashes the result on every call.
const wrapperStyle = css`
  margin: 0 3px;
`

// oxlint-disable-next-line i18next/no-literal-string
const Dot = styled.span<DotProps>`
  display: inline-block;
  width: 3px;
  height: 3px;
  margin: 0 2px;
  background-color: ${baseTheme.colors.gray[400]};
  border-radius: 50%;
  animation-name: ${bounce};
  animation-duration: 1.3s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-delay: ${({ delaySeconds }) => delaySeconds}s;
`

/// Bouncing dots, hidden from screen readers: a caller that needs the state announced has to render
/// its own text for it.
const ThinkingIndicator: React.FC = () => {
  return (
    <span aria-hidden="true" className={wrapperStyle}>
      <Dot delaySeconds={0} />
      <Dot delaySeconds={0.2} />
      <Dot delaySeconds={0.4} />
    </span>
  )
}

export default React.memo(ThinkingIndicator)
